// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"954":"bbc105c3","2152":"445e88b5","2565":"2b75e40f","5129":"83c44024","5522":"e5011be8","6242":"e5011be8"}[chunkId] + ".chunk.css";
};